import { useRoutesList } from '/@/stores/routesList';
import { copyText } from '/@common/utils/format';
import { Session } from '/@common/utils/storage';
import {i18n} from "/@common/i18n";
import { useUserInfo } from '/@/stores/userInfo';
export const parseString2 = (str: any) => {
	let right: any = null;
	let parent: any = null;
	let carry: any = 0;

	let key = '';
	let value = '';

	for (let i = 0; i < str.length; i++) {
		const letter = str[i];

		if (letter === '[') {
			if (right) {
				// 按照下面的模式，你可以自行补齐这里
			} else {
				right = ']';
				parent = new Array();
			}
		} else if (letter === '{') {
			if (right) {
				value = '';
				for (let j = i; j < str.length; j++) {
					value += str[j];
					if (str[j] === '}') {
						i = j;
						// 这里的进位是为了防止在遇到逗号时将空白字符计算进去
						carry = 1;
						break;
					}
				}
				if (right === ']') {
					parent.push(parseString2(value));
					value = '';
				} else if (right === '}') {
					parent[key] = parseString2(value);
					key = '';
					value = '';
				}
			} else {
				right = '}';
				parent = new Object();
			}
		} else if (letter === ']') {
			if (right === letter && value) {
				parent.push(value);
				value = '';
				right = null;
			}
		} else if (letter === '}') {
			if (right === letter && key && value) {
				parent[key] = value;
				key = '';
				value = '';
				right = null;
			}
		} else if (letter === ',') {
			if (carry === 0) {
				if (right === ']') {
					parent.push(value);
					value = '';
				} else if (right === '}') {
					parent[key] = value;
					key = '';
					value = '';
				}
			} else {
				carry--;
			}
		} else if (letter === ':') {
			key = value;
			value = '';
		} else {
			// non empty
			if (letter && letter !== ' ') {
				value += letter;
			}
		}
	}
	return parent;
};
export const UrlSearch = (str: string) => {
	const obj: any = {};
	let num = str.indexOf('?');
	str = str.substr(num + 1); // 取得所有参数   stringvar.substr(start [, length ]

	const arr = str.split('&'); // 各个参数放到数组里
	for (let i = 0; i < arr.length; i++) {
		num = arr[i].indexOf('=');
		if (num > 0) {
			const name = arr[i].substring(0, num);
			const value = arr[i].substr(num + 1);
			obj[name] = value;
		}
	}
	return obj;
};
export const UrlSearchParams = () => {
	const urlObj = new URL(window.location.href);
	const code = urlObj.searchParams.get('code')||'';
	return code;
};
export const getBase64 = (url: string, callback: Function) => {
	let Img = new Image(),
		dataURL = '';
	Img.src = url + '?v=' + Math.random();
	Img.setAttribute('crossOrigin', 'Anonymous');
	Img.onload = function () {
		let canvas = document.createElement('canvas'),
			width = Img.width,
			height = Img.height;
		canvas.width = width;
		canvas.height = height;
		canvas.getContext('2d')?.drawImage(Img, 0, 0, width, height);
		dataURL = canvas.toDataURL('image/jpeg', 1); //可选取多种模式
		return callback ? callback(dataURL) : null; //回掉函数获取Base64编码
	};
};
const imgList: any = ['jpg', 'jpeg', 'png', 'svg', 'SVG', 'JPG', 'JPEG', 'PNG'];
export const changeImgType = (url: any) => {
	let suffix: any = url.substring(url.lastIndexOf('.') + 1);
	return imgList.includes(suffix);
};

// 得到文件后缀
export const getSuffix = (fileName: string) => {
	let suffix = fileName.split('.')[fileName.split('.').length - 1].toLocaleLowerCase();
	return suffix;
};
//生成本地图片url
export const getObjectURL = (file: any) => {
	var url = null;
	if (window.createObjectURL != undefined) {
		// basic
		url = window.createObjectURL(file);
	} else if (window.URL != undefined) {
		// mozilla(firefox)
		url = window.URL.createObjectURL(file);
	} else if (window.webkitURL != undefined) {
		// webkit or chrome
		url = window.webkitURL.createObjectURL(file);
	}
	return url;
};
//file 单位转换
export const formatbytes = (val: any) => {
	if (val == '0') return '0B';
	var k = 1024;
	var sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
	let i = Math.floor(Math.log(val) / Math.log(k)); //得出该数字的单位应该是kB?MB
	return (val / Math.pow(k, i)).toPrecision(3) + '' + sizes[i];
};

export const toggleFontSizeType = (element: any, className: string) => {
	if (!element || !className) return;
	if (className === 'large') {
		for (var i = 12; i <= 30; i++) {
			document.getElementsByTagName('body')[0].style.setProperty(`--font${i}`, `${i + 2}px`);
		}
	} else if (className === 'small') {
		for (var k = 12; k <= 30; k++) {
			document.getElementsByTagName('body')[0].style.setProperty(`--font${k}`, `${k - 2}px`);
		}
	} else {
		for (var j = 12; j <= 30; j++) {
			document.getElementsByTagName('body')[0].style.setProperty(`--font${j}`, `${j}px`);
		}
	}
};
//判断鼠标是否在元素内
export const cursorInElement = (event: MouseEvent, element: string) => {
	var element = document.getElementById(element) as HTMLDivElement;
	const rect = element.getBoundingClientRect();
	const x = event.clientX;
	const y = event.clientY;
	return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
};

import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
dayjs.extend(weekday); // 支持 ISO 周（周一为一周的开始）
export const getRangeShortcuts = () => {
	return [
		{
			label: '今天',
			value: () => [dayjs(), dayjs()],
		},
		{
			label: '昨天',
			value: () => [dayjs().add(-1, 'day'), dayjs().add(-1, 'day')],
		},
		{
			label: '本周',
			value: () => [dayjs().weekday(1), dayjs()],
		},
		{
			label: '上周',
			value: () => [dayjs().weekday(0), dayjs().weekday(-6)],
		},
		{
			label: '本月',
			value: () => [dayjs().date(1), dayjs()],
		},
		{
			label: '上月',
			value: () => [dayjs().subtract(1, 'month').startOf('month'), dayjs().date(0)],
		},
		{
			label: '近7天',
			value: () => [dayjs().add(-7, 'day'), dayjs()],
		},
		{
			label: '近30天',
			value: () => [dayjs().add(-30, 'day'), dayjs()],
		},
		{
			label: '近90天',
			value: () => [dayjs().add(-90, 'day'), dayjs()],
		},
		{
			label: '近半年',
			value: () => [dayjs().add(-6, 'month'), dayjs()],
		},
	];
};

import { v4 as uuidv4 } from 'uuid';

export const getGuestId = (): string => {
	const guestIdKey = 'guestId';
	let guestId = localStorage.getItem(guestIdKey);

	if (guestId === null) {
		guestId = uuidv4();
		localStorage.setItem(guestIdKey, guestId);
	}
	return guestId;
};
export const getTicketId = (): string => {
	const storesRoute = useRoutesList();
	const currentRoute = storesRoute?.currentRoute
	const ticket = currentRoute.params?.ticket ? currentRoute.params?.ticket : '';
	return ticket;
};
export const getFileName = (name: string): string => {
const fileExtension = name.match(/\.([^.]+)$/)?.[1];
return fileExtension? fileExtension.toLowerCase() : '';
}
//长文的内容查看转换公告方法抽取
let indexList = []
export const renderMarkdown = (data: any, level: number = 1, indexArr?: Array): string => {
	if (indexArr) {
		indexList = []
	}
	let markdown = '';
	// 如果当前层级大于 1，才处理序号
	if (level > 1) {
		// 如果当前层级大于 indexList 的长度，说明是新的层级，需要添加一个新的序号
		if (indexList.length < level - 1) {
			indexList.push(1);
		} else {
			// 如果当前层级小于或等于 indexList 的长度，说明是同级或上级层级，需要重置相应的序号
			if (level - 1 < indexList.length) {
				indexList.splice(level - 1, indexList.length - (level - 1));
			}
			indexList[level - 2]++;
		}
		// 生成序号字符串
		let indexStr = indexList.slice(0, level - 1).join('.');

		if (level == 2) {
			indexStr = `第${indexStr}章`
		}
		// 根据 level 生成标题
		if (data?.title.includes('参考文献')) {
			markdown += `<div class="refer">\n\n${'#'.repeat(level)} ${indexStr}  ${data.title}\n\n</div>`;
		} else {
			markdown += `${'#'.repeat(level)} ${indexStr}  ${data.title}\n\n`;
		}

	} else {
		// 直接生成标题，不带序号
		// 根据 level 生成标题
		markdown += `${'#'.repeat(level)} ${data.title}\n\n`;
	}

	// 根据 level 生成标题
	if (data?.title.includes('参考文献')) {
		markdown += `<div class='refer'>\n\n${data.content}\n\n</div>`;
	} else {
		markdown += `${data.content}\n\n`;

	}
	// 递归处理子节点
	if (data.children && data.children.length > 0) {
		data.children.forEach((child: any) => {
			markdown += renderMarkdown(child, level + 1);
		});
	}

	return markdown;
};
export const getSharePonitsUrl=(): string => {
	let code=Session.get('inviteCode');
	let url = `${window.location.origin}/lit/?code=${code}`;
	return url;
};
export const getInviteMessage = async() => {
	let name=Session.get('userName')
	let code=Session.get('inviteCode');
	const copyMessage=[
		`${i18n.global.t('chat.lit.copyLink',{name:name})}\n${i18n.global.t('chat.lit.copyLink1',{link:getSharePonitsUrl()})}\n${i18n.global.t('chat.lit.copyLink2',{code:code})}`,
		`${i18n.global.t('chat.lit.copy1',{code:code,link:getSharePonitsUrl(),number:50})}`,
		`${i18n.global.t('chat.lit.copy2',{code:code,link:getSharePonitsUrl(),number:50})}`,
		`${i18n.global.t('chat.lit.copy3',{code:code,link:getSharePonitsUrl(),number:50})}`
	]
	let randomIndex = Math.floor(Math.random() * copyMessage.length);
	let text=copyMessage[randomIndex]
	copyText({ text });
}



// 同步参数到路由Query（通用方法）- 需要传入路由实例
export const syncParamsToRoute = (
  paramsObj: Record<string, any>,
  routerInstance?: any,
  routeInstance?: any
) => {
  const query: Record<string, any> = {};
  // 遍历参数对象，构建路由查询参数
  for (const [key, value] of Object.entries(paramsObj)) {
    // 检查值是否应该被添加到查询参数中
    
    // 排除 undefined 和 null 值
    if (value === undefined || value === null) {
      continue;
    }
    
    // 排除空字符串
    if (typeof value === 'string' && value.trim() === '') {
      continue;
    }
    
    // 对于数字类型，排除特定字段的默认值
    if (typeof value === 'number') {
      if ((key === 'current' && value === 1) || (key === 'size' && value === 10)) {
        continue; // 跳过默认值
      }
    }
    
    // 所有通过检查的值都添加到查询参数中
    // 这包括值为 0 的数字、true/false 布尔值等
    query[key] = value;
  }
  
  // 如果没有传递路由实例，则尝试使用 composable 获取
  let router: any;
  let route: any;
  
  if (routerInstance && routeInstance) {
    router = routerInstance;
    route = routeInstance;
  } else {
    // 在开发环境中给出警告，因为这可能不会按预期工作
    console.warn('Router and route instances were not provided to syncParamsToRoute. This function may not work correctly outside of a component context.');
    return;
  }
  
  // 只有当查询参数有变化时才更新路由
  if (JSON.stringify(route.query) !== JSON.stringify(query)) {
    router.push({ query });
  }
};

// 从路由参数获取值的通用方法 - 可选择性地接收路由实例
export const getParamsFromRoute = (routeInstance?: any) => {
  let route: any;
  
  if (routeInstance) {
    route = routeInstance;
  } else {
    // 在开发环境中给出警告，因为这可能不会按预期工作
    console.warn('Route instance was not provided to getParamsFromRoute. This function may not work correctly outside of a component context.');
    return {};
  }
  
  const { query } = route;
  
  return query;
};
//根据role跳转不同的路径
export const gotoPageByRole = (role: number,callback?:string) => {
//role=0 时候 跳转到 /lit
//role=1 时候 跳转到 /admin/tenant
//role=2 时候 跳转到 /admin/tenant_overview
//role=3 时候 跳转到 /admin/tenant_overview
	if(role==1){
        window.location.replace('/admin/#/manage/tenant')
	}else if(role==2||role==3){
		window.location.replace('/admin/#/manage/tenantOverview')
	}else{
		window.location.replace(callback?callback:'/lit/#/assiant')
	}
}
export const currentRoleShowGuide = () => {
	const hostname = window.location.hostname;
	const currentDomain = Session.get('currentDomain');
	if (currentDomain && currentDomain !== hostname) {
		return true
	}
	const stores = useUserInfo();
	const role= Session.get('role') || stores.userInfos?.role
    const currentHash = window.location.hash;
	if(role!=undefined&&role!=0&&currentHash.includes('login')){
		return true
	}else if(role==0&&currentHash.includes('manageLogin')){
		return true
	}else{
		return false
	}
}